export const NAME = 'paddingMachines';